export const Logo = (props) => {
  return (
    <svg
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 145.45 145.45"
    >
      <defs></defs>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <circle className="razz-fill" cx="72.73" cy="72.73" r="72.73" />
          <path className="cls-2" d="M86.09,16A38.45,38.45,0,0,0,48.52,54.42" />
          <path
            className="cls-2"
            d="M86.08,94.55A38.45,38.45,0,0,1,48.5,56.11"
          />
          <line className="cls-2" x1="48.52" y1="53.5" x2="48.52" y2="123.49" />
          <line
            className="cls-2"
            x1="88.58"
            y1="13.33"
            x2="88.58"
            y2="124.55"
          />
        </g>
      </g>
    </svg>
  );
};
